
import { useRef, useState } from "react";
import { Modal as AntdModal, Collapse } from 'antd';
import Modal from "../utils/Modal";
import ScriptingHelp from "../script/ScriptingHelp";


// import { Select, Spin, Modal, Button, List, Tag, Avatar, message } from 'antd';

// import { useSelector } from 'react-redux';

// import { selectId } from '../../redux/features/idSlice';
// import { selectToken } from '../../redux/features/tokenSlice';

import FormService from '../../../redux/services/forms';
import SharePage from './SharePage';

import { getHeight, layouts } from "../misc/layouts";

export default function FormView({
    reference,
    comps,
    setComps,
    content,
    position,
    size,
    pages,
    setPages,
    currentPage,
    setCurrentPage,
    setSelectedEl,
    setContextMenu,
    css,
    formId,
    user,
    onFormSave,
    magneticGrid,
    setMagneticGrid,
    magneticGridPartitions,
    setMagneticGridPartitions,
    layout,
    setLayout,
    onUndo,
    onRedo,
    canUndo,
    canRedo,
    setMultiSel,
    magneticSnap,
    setMagneticSnap
}) {
    const [view, setView] = useState('');
    const [showPagePicker, setShowPagePicker] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    const [marqueeBox, setMarqueeBox] = useState(null); // { left, top, width, height } in form-view px
    const didMarqueeSelect = useRef(false);

    const goToPage = (i) => {
        setCurrentPage(i);
        setVisibilityLoaded(false);
        setEditabilityLoaded(false);
    };

    // Rubber-band multi-select: drag a box across empty canvas to select every
    // element it intersects on the current page. Everything is computed in
    // viewport coordinates and hit-tested against the elements' real DOM rects,
    // so it makes no assumptions about the .form-view positioning context.
    const onCanvasMouseDown = (e) => {
        // A fresh interaction clears any stale click-suppression flag (in case
        // the previous drag's click event never fired).
        didMarqueeSelect.current = false;
        // Only start on the canvas background, not on an element.
        if (e.target !== e.currentTarget || e.button !== 0) return;
        // Stop the drag from turning into a text selection on the page.
        e.preventDefault();
        const prevUserSelect = document.body.style.userSelect;
        document.body.style.userSelect = 'none';
        const formViewEl = e.currentTarget;
        const start = { x: e.clientX, y: e.clientY };
        let moved = false;
        setMarqueeBox({ left: start.x, top: start.y, width: 0, height: 0 });

        const onMove = (ev) => {
            if (Math.abs(ev.clientX - start.x) > 3 || Math.abs(ev.clientY - start.y) > 3) moved = true;
            setMarqueeBox({
                left: Math.min(start.x, ev.clientX),
                top: Math.min(start.y, ev.clientY),
                width: Math.abs(ev.clientX - start.x),
                height: Math.abs(ev.clientY - start.y)
            });
        };
        const onUp = (ev) => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
            document.body.style.userSelect = prevUserSelect;
            setMarqueeBox(null);
            if (!moved) return; // a plain click → let onClick deselect

            const mx1 = Math.min(start.x, ev.clientX);
            const my1 = Math.min(start.y, ev.clientY);
            const mx2 = Math.max(start.x, ev.clientX);
            const my2 = Math.max(start.y, ev.clientY);

            // The visible .comp nodes are in the same order as the current
            // page's element indices, so pair them up by position.
            const pageIndices = [];
            for (let k = 0; k < comps.length; k++) {
                if (comps[k].page === currentPage) pageIndices.push(k);
            }
            const nodes = formViewEl.getElementsByClassName('comp');

            const hits = [];
            for (let i = 0; i < nodes.length && i < pageIndices.length; i++) {
                const r = nodes[i].getBoundingClientRect();
                if (r.left < mx2 && r.right > mx1 && r.top < my2 && r.bottom > my1) {
                    hits.push(pageIndices[i]);
                }
            }

            didMarqueeSelect.current = true; // suppress the trailing click's deselect
            if (hits.length > 1) {
                setMultiSel(hits);
                setSelectedEl(-1);
            } else if (hits.length === 1) {
                setSelectedEl(hits[0]);
                setMultiSel([]);
            } else {
                setMultiSel([]);
                setSelectedEl(-1);
            }
        };

        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
    };
    // '' == no action, 'left' == add page to left, 'right' == add page to right

    const [visibilityLoaded, setVisibilityLoaded] = useState(false); // refreshes visibility
    const [refreshVisibility, setRefreshVisibility] = useState(false); // refreshes visibility
    const [visibilityStatus, setVisibilityStatus] = useState(0);

    const [visibilityList, setVisibilityList] = useState([]);

    const [editabilityLoaded, setEditabilityLoaded] = useState(false); // refreshes editability
    const [refreshEditability, setRefreshEditability] = useState(false); // refreshes editability
    const [editabilityStatus, setEditabilityStatus] = useState(0);
    const [editabilityList, setEditabilityList] = useState([]);

    const [isAddingGroup, setIsAddingGroup] = useState(false);
    const [isAddingEditGroup, setIsAddingEditGroup] = useState(false);

    const [members, setMembers] = useState([]);

    // useEffect(() => {
    //     console.log('form width', reference.current ? reference.current.offsetWidth : window.innerWidth * 0.6);
    //   }, [reference.current]);

    if (!visibilityLoaded) {
        if (pages[currentPage].visibleTo === 'all') {
            setVisibilityStatus(0);
        } else {
            setVisibilityStatus(1);
            setVisibilityList(pages[currentPage].visibleTo);
        } setVisibilityLoaded(true);
    }

    if (refreshVisibility) {
        if (pages[currentPage].visibleTo === 'all') {
            setVisibilityStatus(0);
        } else {
            setVisibilityStatus(1);
            setVisibilityList(pages[currentPage].visibleTo);
        } setRefreshVisibility(false);
    }

    if (!editabilityLoaded) {
        if (pages[currentPage].editableTo === 'all') {
            setEditabilityStatus(0);
        } else {
            setEditabilityStatus(1);
            setEditabilityList(pages[currentPage].editableTo);
        } setEditabilityLoaded(true);
    }

    if (refreshEditability) {
        if (pages[currentPage].editableTo === 'all') {
            setEditabilityStatus(0);
        } else {
            setEditabilityStatus(1);
            setEditabilityList(pages[currentPage].editableTo);
        } setRefreshEditability(false);
    }

    let selected_members_render = [];
    let members_render = [];

    let selected_edit_members_render = [];
    let edit_members_render = [];

    try {
        for (let k = 0; k < visibilityList.length; ++k) {
            selected_members_render.push(
                <div style={{
                    fontWeight: '300',
                    fontSize: '1vmax',
                    width: '90%',
                    marginLeft: '5%',
                    padding: '1vmax 0',
                    textAlign: 'center',
                    border: '1pt solid #faf3dd',
                    marginTop: k === 0 ? '2vmax' : '0'
                }}>
                    {visibilityList[k]}
                    <a className='panel-button' style={{
                        marginLeft: '1vmax',
                        border: '0pt',
                        borderLeft: '1pt solid #faf3dd',
                        padding: '0.5vmax 1vmax'
                    }} onClick={(e) => {
                        e.preventDefault();
                        let new_visibility_list = [...visibilityList];
                        new_visibility_list.splice(k, 1);
                        setVisibilityList(new_visibility_list);
                    }}>Delete</a>
                </div>
            );
        }

        for (let k = 0; k < members.length; ++k) {
            members_render.push(
                <a className='panel-button' style={{
                    fontWeight: '300',
                    fontSize: '1vmax',
                    padding: '1vmax',
                    width: '90%'
                }} onClick={(e) => {
                    e.preventDefault();
                    if (!visibilityList.includes(members[k].name)) {
                        let new_visibility_list = [...visibilityList];
                        new_visibility_list.push(members[k].name);
                        setVisibilityList(new_visibility_list);
                        setIsAddingGroup(false);
                    }
                }}>{members[k].name}</a>
            );
        }

        for (let k = 0; k < editabilityList.length; ++k) {
            selected_edit_members_render.push(
                <div style={{
                    fontWeight: '300',
                    fontSize: '1vmax',
                    width: '90%',
                    marginLeft: '5%',
                    padding: '1vmax 0',
                    textAlign: 'center',
                    border: '1pt solid #faf3dd',
                    marginTop: k === 0 ? '2vmax' : '0'
                }}>
                    {editabilityList[k]}
                    <a className='panel-button' style={{
                        marginLeft: '1vmax',
                        border: '0pt',
                        borderLeft: '1pt solid #faf3dd',
                        padding: '0.5vmax 1vmax'
                    }} onClick={(e) => {
                        e.preventDefault();
                        let new_editability_list = [...editabilityList];
                        new_editability_list.splice(k, 1);
                        setEditabilityList(new_editability_list);
                    }}>Delete</a>
                </div>
            );
        }

        for (let k = 0; k < members.length; ++k) {
            edit_members_render.push(
                <a className='panel-button' style={{
                    fontWeight: '300',
                    fontSize: '1vmax',
                    padding: '1vmax',
                    width: '90%'
                }} onClick={(e) => {
                    e.preventDefault();
                    if (!editabilityList.includes(members[k].name)) {
                        let new_editability_list = [...editabilityList];
                        new_editability_list.push(members[k].name);
                        setEditabilityList(new_editability_list);
                        setIsAddingEditGroup(false);
                    }
                }}>{members[k].name}</a>
            );
        }
    } catch (err) {

    }

    function wrap(str) {
        return 'calc(' + str + ')';
    }


    // let boundaryHeight = document.getElementById("form-view")?.offsetWidth;
    // if (boundaryHeight) {
    //     boundaryHeight = boundaryHeight * 1.414;
    // }
    return (

        <div id='fv' className="form-designer">
            <div className="editor-topbar">
                <div className="topbar-left">
                    <button type="button" className="ur-btn" disabled={!canUndo}
                        title="Undo" onClick={() => { if (canUndo && onUndo) onUndo(); }}>
                        <i className="fa fa-solid fa-undo"></i>
                        Undo
                    </button>
                    <button type="button" className="ur-btn" disabled={!canRedo}
                        title="Redo" onClick={() => { if (canRedo && onRedo) onRedo(); }}>
                        <i className="fa fa-solid fa-repeat"></i>
                        Redo
                    </button>
                    <span className="snap-tip-wrap">
                        <button type="button"
                            className={"ur-btn ur-icon-btn" + (magneticSnap ? " ur-btn-active" : "")}
                            onClick={() => { if (setMagneticSnap) setMagneticSnap(!magneticSnap); }}>
                            <i className="fa fa-solid fa-magnet"></i>
                        </button>
                        <span className="snap-tip">{"Magnetic Alignment is " + (magneticSnap ? "On" : "Off")}</span>
                    </span>
                </div>
                <div className="topbar-center">
                    <i className="fa fa-solid fa-angle-left panel-button" style={{ fontSize: '1.1vmax' }}
                        title="Previous page" onClick={() => {
                            if (currentPage !== 0) {
                                setCurrentPage(currentPage - 1);
                                setVisibilityLoaded(false);
                                setEditabilityLoaded(false);
                            } else {
                                setView('left');
                            }
                        }}></i>
                    <p className='panel-label pointy' style={{ margin: 0 }}
                        title="Go to page" onClick={() => setShowPagePicker(true)}>Page {currentPage + 1}/{pages.length}</p>
                    <i className="fa fa-solid fa-angle-right panel-button" style={{ fontSize: '1.1vmax' }}
                        title="Next page" onClick={() => {
                            if (currentPage !== pages.length - 1) {
                                setCurrentPage(currentPage + 1);
                                setVisibilityLoaded(false);
                                setEditabilityLoaded(false);
                            } else {
                                setView('right');
                            }
                        }}></i>
                </div>
                <div className="topbar-right">
                    {
                        (pages != null && pages[currentPage] != null) ?
                            <SharePage onFormSave={onFormSave} formId={formId} user={user} page={pages[currentPage]}
                                magneticGrid={magneticGrid} setMagneticGrid={setMagneticGrid}
                                magneticGridPartitions={magneticGridPartitions}
                                setMagneticGridPartitions={setMagneticGridPartitions} /> : null
                    }
                </div>
            </div>
            {/* <div className="formDesignerBoundary"> */}
            <div ref={reference} className='form-view' id="form-view" style={{
                width: wrap(size.w),
                // height: (pages[currentPage].height * 60).toString() + 'vw',

                // new way to precisely set page height -- not here before.
                height: (pages[currentPage].height * (reference.current ? reference.current.offsetWidth : window.innerWidth * 0.6)).toString() + 'px',
                // backgroundColor: '#ccc',
            }}
                onMouseDown={onCanvasMouseDown}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // Ignore the click that ends a marquee drag so it doesn't
                    // immediately clear the selection we just made.
                    if (didMarqueeSelect.current) {
                        didMarqueeSelect.current = false;
                        return;
                    }
                    setSelectedEl(-1);
                    if (setMultiSel) setMultiSel([]);
                    setContextMenu([false, -1, [0, 0]]);
                }}>
                {content}
                {marqueeBox ? <div className="marquee-box" style={{
                    left: marqueeBox.left,
                    top: marqueeBox.top,
                    width: marqueeBox.width,
                    height: marqueeBox.height
                }} /> : null}
            </div>
            {/* </div> */}
            {/* <span className="boundaryInfo" style={{ top: boundaryHeight }}>PDF Limit</span> */}
            <div className="form-designer-footer" style={{
                marginTop: '10px'
            }}>
                {layouts.includes(layout) ? <></> : <div style={{
                    color: 'var(--ed-text-soft)',
                    textAlign: 'center',
                    padding: 5,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '0.75vmax'
                }}>
                    <i className="fa fa-solid fa-angle-up panel-button" style={{
                        fontSize: '1.5vmax'
                    }} title="Decrease page height" onClick={() => {
                        if (pages[currentPage].height >= 0.3) {
                            let new_pages = [...pages];
                            new_pages[currentPage].height -= .1;
                            setPages(new_pages);
                        }
                    }}></i>
                    <i className="fa fa-solid fa-angle-down panel-button" style={{
                        fontSize: '1.5vmax'
                    }} title="Increase page height" onClick={() => {
                        let new_pages = [...pages];
                        new_pages[currentPage].height += .1;
                        setPages(new_pages);
                    }}></i>
                </div>}

                <div style={{ textAlign: 'center', padding: '6px 0 2px' }}>
                    <button type="button" className="panel-button" style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6
                    }} onClick={() => setShowHelp(true)}>
                        <i className="fa fa-solid fa-question-circle"></i>
                        Help
                    </button>
                </div>

                <AntdModal className="cf-modal" title="Form Editor — Quick Guide" width={720}
                    visible={showHelp} footer={null} onOk={() => setShowHelp(false)} onCancel={() => setShowHelp(false)}>
                    <div style={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: 8, lineHeight: 1.55 }}>
                        <p style={{ color: 'var(--ed-text-soft)', marginTop: 0 }}>
                            A quick tour of the form editor. You build a form by placing elements
                            onto the dotted page and arranging them. The left panel edits whatever
                            is selected; the toolbar at the bottom-right holds the main actions.
                        </p>

                        <h3 className="help-h">1. Add elements</h3>
                        <ul className="help-ul">
                            <li>Open <b>Add element</b> from the bottom-right toolbar.</li>
                            <li><b>Primitive</b> elements are the basics — Label, Input, Button, Checkbox, Radio, Dropdown, List, Image, Box.</li>
                            <li><b>Intermediate</b> elements are composites — Input Table, Signature, Snapshot.</li>
                            <li>Click one to drop it on the current page.</li>
                        </ul>

                        <h3 className="help-h">2. Select &amp; edit</h3>
                        <ul className="help-ul">
                            <li>Click an element to select it — it gets a blue outline.</li>
                            <li>The <b>Properties</b> panel (top-left) edits the selected element: position, size, text, colors, borders, content, and more.</li>
                            <li>The <b>Elements</b> panel (bottom-left) lists everything on the page. Click a row to select it (the list scrolls to it), double-click to rename, and drag rows to reorder.</li>
                        </ul>

                        <h3 className="help-h">3. Move, resize &amp; align</h3>
                        <ul className="help-ul">
                            <li>Drag an element to move it; drag its handles to resize.</li>
                            <li><b>Magnetic Alignment</b> (the magnet button in the top bar) shows guide lines and snaps edges/centers to other elements as you drag or resize.</li>
                            <li><b>Magnetic Grid</b> (top-right) snaps to a fixed grid instead.</li>
                            <li>Use <b>Undo / Redo</b> in the top bar to step through changes.</li>
                        </ul>

                        <h3 className="help-h">4. Work with many at once</h3>
                        <ul className="help-ul">
                            <li>Drag a box across empty canvas to select everything inside it, or <b>Shift+click</b> elements to add/remove them from the selection.</li>
                            <li>Move or resize the whole group together.</li>
                            <li>The Properties panel then shows only the settings common to all selected elements (and lets you set one shared script).</li>
                            <li>Press <b>Delete</b> to remove the selection, <b>Esc</b> to deselect.</li>
                        </ul>

                        <h3 className="help-h">5. Pages</h3>
                        <ul className="help-ul">
                            <li>A form can have multiple pages. Use the <b>◀ ▶</b> arrows in the top bar, or click <b>“Page i/N”</b> to jump to a specific page.</li>
                            <li>The <b>Pages</b> toolbar action lets you add, delete, and drag-reorder pages.</li>
                        </ul>

                        <h3 className="help-h">6. Variables, Flags &amp; Scripts</h3>
                        <ul className="help-ul">
                            <li><b>Variables</b> and <b>Flags &amp; externals</b> (toolbar) define reusable values and shared states for the form.</li>
                            <li>Each element can carry a <b>Script</b> — open <b>Edit Script</b> in its properties to add dynamic behavior with the visual block editor (logic that runs on start, on change, and on save).</li>
                        </ul>

                        <h3 className="help-h">7. Save &amp; shortcuts</h3>
                        <ul className="help-ul">
                            <li>Press <b>Ctrl/Cmd + Enter</b> to save the form.</li>
                            <li><b>Right-click</b> an element (or a multi-selection) for quick actions: Duplicate, move To Left / To Right page, and Delete.</li>
                        </ul>

                        <Collapse style={{ marginTop: 16 }}>
                            <Collapse.Panel header="Scripting (AtlasScript) — expand for the scripting guide" key="scripting">
                                <ScriptingHelp />
                            </Collapse.Panel>
                        </Collapse>

                        <p style={{ color: 'var(--ed-text-soft)', marginTop: 16 }}>
                            That's enough to get going — poke around the Properties panel and the
                            right-click menu to discover the rest.
                        </p>
                    </div>
                </AntdModal>

                {
                    showPagePicker ? <Modal light width='20' height='42'>
                        <p style={{
                            fontWeight: 600,
                            fontSize: '1.15vmax',
                            marginTop: '3vh',
                            padding: '0 1vmax'
                        }}>Go to page</p>
                        <div style={{
                            maxHeight: '28vh',
                            overflowY: 'auto',
                            padding: '0.5vmax 1vmax',
                            marginTop: '1vh'
                        }}>
                            {pages.map((_, i) => (
                                <a key={i} className='panel-button' style={{
                                    display: 'block',
                                    width: '85%',
                                    margin: '0.4vmax auto',
                                    ...(i === currentPage ? {
                                        background: 'var(--ed-accent-soft)',
                                        borderColor: 'var(--ed-accent)',
                                        color: 'var(--ed-accent)'
                                    } : {})
                                }} onClick={(e) => {
                                    e.preventDefault();
                                    goToPage(i);
                                    setShowPagePicker(false);
                                }}>Page {i + 1}{i === currentPage ? ' (current)' : ''}</a>
                            ))}
                        </div>
                        <a className='panel-button' style={{ marginTop: '1vh' }} onClick={(e) => {
                            e.preventDefault();
                            setShowPagePicker(false);
                        }}>Cancel</a>
                    </Modal> : <></>
                }

                {
                    view === 'left' ? <Modal light width='15' height='15'>
                        <p style={{
                            fontWeight: '400',
                            fontSize: '1.25vmax',
                            marginTop: '3vh'
                        }}>Create new page?</p>
                        <a className='panel-button' style={{
                            marginRight: '1vmax'
                        }} onClick={() => {
                            let new_comps = [...comps];
                            for (let k = 0; k < new_comps.length; k++) {
                                new_comps[k].page += 1;
                            } setComps(new_comps);
                            let new_pages = [...pages];
                            new_pages.splice(0, 0, {
                                page_id: FormService.getGUID(),
                                height: getHeight('A4', 0.7),
                                visibleTo: 'all',
                                editableTo: 'all'
                            }); setPages(new_pages);
                            setView('');
                            setVisibilityLoaded(false);
                            setEditabilityLoaded(false);
                        }}>Yes</a>
                        <a className='panel-button' onClick={() => {
                            setView('');
                        }}>No</a>
                    </Modal> : <></>
                }

                {
                    view === 'right' ? <Modal light width='15' height='15'>
                        <p style={{
                            fontWeight: '400',
                            fontSize: '1.25vmax',
                            marginTop: '3vh'
                        }}>Create new page?</p>
                        <a className='panel-button' style={{
                            marginRight: '1vmax'
                        }} onClick={() => {
                            let new_pages = [...pages];
                            new_pages.push({
                                page_id: FormService.getGUID(),
                                height: getHeight('A4', 0.7),
                                visibleTo: 'all',
                                editableTo: 'all'
                            }); setPages(new_pages);
                            setCurrentPage(currentPage + 1);
                            setView('');
                            setVisibilityLoaded(false);
                            setEditabilityLoaded(false);
                        }}>Yes</a>
                        <a className='panel-button' onClick={() => {
                            setView('');
                        }}>No</a>
                    </Modal> : <></>
                }


            </div>
        </div>
    );

}
